<template lang="html">
  <div class="">
    <div class="container">
      <div class="form-container">
        <el-form
          ref="episodeDraft"
          :model="draft"
          :rules="rules"
          label-position="right"
          label-width="120px"
        >
          <h5>基本信息</h5>
          <!-- <el-divider content-position="center"></el-divider> -->
          <!-- <el-form-item label="栏目">
            <el-select
              v-model="draft.category"
              placeholder="请选择所属栏目"
              style="width:100%"
            >
              <el-option
                v-for="(category, index) in categories"
                :key="index"
                :label="category.label"
                :value="category.id"
              >
              </el-option>

            </el-select>
          </el-form-item> -->
          <el-form-item
            required
            label="标题"
            prop="title"
          >
            <el-input v-model="draft.title"></el-input>
          </el-form-item>
          <el-form-item
            required
            label="简介"
            prop="description"
          >
            <el-input
              type="textarea"
              v-model="draft.description"
              :autosize="{ minRows: 5, maxRows: 10}"
            >
            </el-input>
          </el-form-item>
          <!-- <h5>本期主播</h5>
          <el-form-item>
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="draft.checkAllHosts"
              @change="handleCheckAllChange"
            >
              全选
            </el-checkbox>
            <el-checkbox-group
              v-model="draft.checkedHosts"
              @change="handleCheckedHostsChange"
            >
              <el-checkbox
                v-for="host in hosts"
                :key="host"
                :label="host"
              >
                {{host}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
          <h5>图片文件</h5>
          <el-form-item
            label="封面"
            required
            prop="cover"
            ref="uploadCover"
          >
            <file-uploader
              :showSlug="showSlug"
              file-type="Image"
              text="上传节目封面"
              tip="只能上传jpg/png文件，且不超过2M；建议宽200px/高200px"
              list-type="picture"
              :limit="1"
              :id-list="coverIds"
              :size-limit="2 * 1024 * 1024"
              :allowed-types="['image/jpeg', 'image/jpg', 'image/png']"
              @upload-success="handleCoverUploadSuccess"
              @file-removed="handleCoverRemoved"
            />
          </el-form-item>
          <el-form-item
            label="海报"
            required
            prop="poster"
            ref="uploadPoster"
          >
            <file-uploader
              :showSlug="showSlug"
              file-type="Image"
              text="上传节目海报"
              tip="只能上传jpg/png文件，且不超过2M；建议宽200px/高600px"
              list-type="picture"
              :size-limit="2 * 1024 * 1024"
              :allowed-types="['image/jpeg', 'image/jpg', 'image/png']"
              :limit="1"
              :id-list="posterIds"
              @upload-success="handlePosterUploadSuccess"
            />
          </el-form-item>
          <el-form-item label="内文图片">
            <file-uploader
              :showSlug="showSlug"
              file-type="Image"
              text="上传相关图片"
              tip="可传多张(不超过24张)，只能上传jpg/png文件，且每张不超过2M"
              list-type="picture"
              :size-limit="2 * 1024 * 1024"
              :allowed-types="['image/jpeg', 'image/jpg', 'image/png']"
              :limit="24"
              :id-list="draft.images"
              @upload-success="handleImagesUploadSuccess"
            />
          </el-form-item>
          <h5>音频文件</h5>
          <el-form-item
            label="完整"
            required
            prop="audios"
            ref="uploadFullAudio"
          >
            <file-uploader
              :showSlug="showSlug"
              file-type="Audio"
              text="上传完整音频"
              tip="只能上传mp3文件，且不超过500M"
              :limit="1"
              list-type="picture"
              :size-limit="500 * 1024 * 1024"
              :allowed-types="['audio/mp3', 'audio/mpeg']"
              :id-list="draft.audios"
              @upload-success="handleAudiosUploadSuccess"
              @file-removed="handleFullAudioRemoved"
            />
          </el-form-item>
          <el-form-item label="试听">
            <file-uploader
              :showSlug="showSlug"
              file-type="Audio"
              text="上传试听音频"
              tip="只能上传mp3文件，且不超过100M；建议长度为2分钟"
              list-type="picture"
              :size-limit="100 * 1024 * 1024"
              :allowed-types="['audio/mp3', 'audio/mpeg']"
              :limit="1"
              :id-list="draft.trails"
              @upload-success="handleTrailsUploadSuccess"
            />
          </el-form-item>
          <h5>付费设置</h5>
          <el-form-item label="价格">
            <el-select
              v-model="draft.price.id"
              placeholder="请选择单集价格，不设置则为免费节目"
              clearable
              style="width:100%"
            >
              <!-- <el-option
                v-for="(price, index) in prices"
                :key="index"
                :label="price.amount / 100 + '元'"
                :value="price.id"
              > -->
              <el-option
                v-for="(price, index) in prices"
                :key="index"
                :label="price.label + ' ' + '(' + price.amount / 100 + '元)'"
                :value="price.id"
              >
              </el-option>
              <!-- <el-option label="价格1 (3元)" value="1"></el-option>
              <el-option label="价格2 (5元)" value="2"></el-option> -->
            </el-select>
          </el-form-item>
          <!-- <h5>编辑推荐</h5>
          <el-form-item label="入选推荐">
            <el-switch
              v-model="draft.editor_choice"
            >
            </el-switch>
          </el-form-item> -->
          <h5>立即发布</h5>
          <el-form-item label="发布">
            <el-switch
              v-model="draft.published"
            >
            </el-switch>
          </el-form-item>
          <el-form-item style="margin-top:40px;">
            <el-button
              type="primary"
              size="medium"
              @click="onSubmit">
              {{submitButtonLabel}}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  // let COS = require('cos-js-sdk-v5')
  import { Message } from 'element-ui'
  import FileUploader from './file-uploader.vue'
  import VueLocalStorage from 'vue-localstorage'
  import Vue from 'vue'
  import router from '../router'
  Vue.use(VueLocalStorage)
  export default {
    components: {
      FileUploader
    },
    props: {
      mode: {
        type: String,
        default: '' // create or update
      },
      showSlug: {
        type: String,
        default: ''
      },
      episodeId: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        // hosts: ['大肠', '小明', '高玄', '和平', '小佛'],
        // isIndeterminate: false,
        submitting: false,
        categories: [],
        prices: [], // 可以选择的价格
        draft: {
          show: 1,
          published: false,
          title: '',
          category: '',
          description: '',
          // checkAllHosts: false,
          // checkedHosts: [],
          editor_choice: false,
          cover: null,
          poster: null,
          images: [],
          audios: [],
          trails: [],
          price: {
            id: null,
            amount: 0,
            origin: 0
          },
          uploadedFiles: {}
        },
        rules: {
          title: [
            { required: true, message: '请输入单集标题', trigger: 'blur' },
            { max: 200, message: '长度不超过200个字符', trigger: 'blur' }
          ],
          description: [
            { required: true, message: '请输入单集简介', trigger: 'blur' }
          ],
          cover: [
            { required: true, message: '请上传单集封面图片', trigger: 'blur' }
          ],
          poster: [
            { required: true, message: '请上传单集海报图片', trigger: 'blur' }
          ],
          fullaudio: [
            { required: true, message: '请上传单集完整音频', trigger: 'blur' }
          ]
        }
      };
    },
    computed: {
      submitButtonLabel () {
        let label
        if (this.mode == 'create') {
          label = '确定提交'
        } else if (this.mode == 'update') {
          label = '提交修改'
        }
        return label
      },
      coverIds () {
        let ids = []
        if (this.draft.cover) {
          ids = [this.draft.cover]
          window.console.log("ids:")
          window.console.log(ids)
        }
        return ids
      },
      posterIds () {
        let ids = []
        if (this.draft.poster) {
          ids = [this.draft.poster]
        }
        return ids
      }
    },
    methods: {
      onSubmit () {
        window.console.log("onSubmit")
        this.$refs["episodeDraft"].validate((valid) => {
          if (valid) {
            window.console.log("表单校验通过，可以提交")
            let that = this
            that.$api.show.getId(that.$route.params.slug).then(res => {
              that.draft.show = res.data.id
              if (that.mode == 'create') {
                that.$api.episode.create(that.draft).then(res => {
                  window.console.log("Episode创建成功")
                  window.console.log(res)
                  let episodeTitle = res.data.title
                  let episodeId = res.data.id
                  // 处理发布成功后逻辑
                  that.submitting = true
                  let message
                  if (res.data.published) {
                    message = `单集已发布：${episodeTitle}`
                  } else {
                    message = `单集草稿已保存：${episodeTitle}`
                  }
                  Message.success({
                    message: message
                  })
                  Vue.localStorage.remove('draft')
                  // 该处理reset表单、跳转管理单集页面、成功提示消息的业务逻辑
                  that.$refs.episodeDraft.resetFields()
                  router.push(
                    {
                      name: 'EpisodeList',
                      params: {
                        slug: that.$route.params.slug
                      }
                    }
                  )
                  if (that.draft.price.id) {
                    let params = {
                      priceid: that.draft.price.id,
                      applabel: 'program',
                      classname: 'episode',
                      objectid: episodeId
                    }
                    window.console.log("创建价格条目：")
                    window.console.log(params)
                    window.console.log("选择了价格")
                    that.$api.priceItem.create(params).then(res => {
                      window.console.log("成功创建price item")
                      window.console.log(res)
                    })
                  }
                })
              } else if (that.mode == 'update') {
                that.$api.episode.update(
                  that.episodeId, that.draft).then(res => {
                  window.console.log("Episode更新成功")
                  window.console.log(res)
                  let episodeId = res.data.id
                  if (that.draft.price.id != res.data.price.id) {
                    let params = {
                      priceid: that.draft.price.id,
                      applabel: 'program',
                      classname: 'episode',
                      objectid: episodeId
                    }
                    that.$api.priceItem.create(params).then(res => {
                      window.console.log("成功更新price item")
                      window.console.log(res)
                    })
                  }
                  Message.success({
                    message: `单集已更新：${res.data.title}`
                  })
                  // 该处理reset表单、跳转管理单集页面、成功提示消息的业务逻辑
                  that.$refs.episodeDraft.resetFields()
                  router.push(
                    {
                      name: 'EpisodeList',
                      params: {
                        slug: that.$route.params.slug
                      }
                    }
                  )
                })
              }
            })
          } else {
            Message.error({
              message: `请检查表单填写是否正确、完整`
            })
            window.console.log('error submit!!');
            return false;
          }
        })
      },
      handleCheckAllChange(val) {
        this.draft.checkedHosts = val ? this.hosts : [];
        this.isIndeterminate = false;
      },
      handleCheckedHostsChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.hosts.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.hosts.length;
      },
      handleCoverUploadSuccess(event) {
        window.console.log("封面上传成功")
        window.console.log(event.fileName)
        window.console.log(event.fileId)
        this.draft.cover = event.fileId
        // let uploadedFiles = this.draft.uploadedFiles
        // uploadedFiles[event.fileName] = event.fileId
        // this.draft.uploadedFiles = uploadedFiles
        // window.console.log(this.draft.uploadedFiles)
        this.saveToUploadFiles(event)
        this.$refs.uploadCover.clearValidate()
      },
      handleCoverRemoved(event) {
        window.console.log(this.draft.uploadedFiles)
        window.console.log("封面图片已经被删除")
        window.console.log(event.fileName)
        let fileId = this.draft.uploadedFiles[event.fileName]
        window.console.log(fileId)
        window.console.log(this.draft.cover)
        if (this.draft.cover == fileId) {
          window.console.log("应该删除cover")
          this.draft.cover = null
        }
      },
      handlePosterUploadSuccess(event) {
        window.console.log("海报上传成功")
        window.console.log(event.fileId)
        this.draft.poster = event.fileId
        this.$refs.uploadPoster.clearValidate()
      },
      handleImagesUploadSuccess(event) {
        window.console.log("内文图片上传成功")
        window.console.log(event.fileId)
        this.draft.images.push(event.fileId)
        this.draft.images = Object.assign([], this.draft.images)
        window.console.log(this.draft.images)
      },
      handleAudiosUploadSuccess(event) {
        window.console.log("完整音频上传成功")
        window.console.log(event.fileId)
        this.draft.audios.push(event.fileId)
        this.draft.audios = Object.assign([], this.draft.audios)
        window.console.log(this.draft.audios)
        this.saveToUploadFiles(event)
        this.$refs.uploadFullAudio.clearValidate()
      },
      handleFullAudioRemoved(event) {
        window.console.log(this.draft.uploadedFiles)
        window.console.log("单集完整音频已经被删除")
        window.console.log(event.fileName)
        window.console.log(this.draft.uploadedFiles)
        let fileId = this.draft.uploadedFiles[event.fileName]
        window.console.log("fileId:")
        window.console.log(fileId)
        window.console.log(this.draft.audios)
        let audios = this.draft.audios
        let idx = audios.indexOf(fileId)
        window.console.log("idx:")
        window.console.log(idx)
        audios.splice(idx, 1)
        this.draft.audios = audios
      },
      handleTrailsUploadSuccess(event) {
        window.console.log("试听音频上传成功")
        window.console.log(event.fileId)
        this.draft.trails.push(event.fileId)
        this.draft.trails = Object.assign([], this.draft.trails)
        this.saveToUploadFiles(event)
        window.console.log(this.draft.trails)
      },
      loadFromLocalStorage() {
        window.console.log("从本地存储读取草稿")
        let draft = Vue.localStorage.get('draft')
        if (draft) {
          window.console.log(draft)
          this.draft = JSON.parse(draft)
        }
      },
      saveToLocalStorage(draft) {
        window.console.log("将草稿保存到本地存储")
        window.console.log(draft)
        if (draft) {
          Vue.localStorage.set('draft', JSON.stringify(draft))
        }
      },
      saveToUploadFiles(event) {
        let uploadedFiles = this.draft.uploadedFiles
        uploadedFiles[event.fileName] = event.fileId
        this.draft.uploadedFiles = uploadedFiles
      },
      getCategories(showSlug) {
        let that = this
        let params = {
          showSlug: showSlug
        }
        that.$api.category.list(params).then(res => {
          window.console.log("获取到栏目列表")
          window.console.log(res.data.results)
          that.categories = res.data.results
          // that.categories = Object.assign([], that.categories)
        })
      },
      getPrices(showSlug) {
        let that = this
        that.$api.show.getPrices(showSlug).then(res => {
          window.console.log("获取到Show Prices")
          window.console.log(res)
          that.prices = res.data
        })
      },
      getEpisode(episodeId) {
        let that = this
        window.console.log("获取已有的Episode")
        window.console.log(episodeId)
        let params = {
          includeDraft: true
        }
        that.$api.episode.detail(episodeId, params).then(res => {
          window.console.log("获取到Episode Detail")
          window.console.log(res)
          window.console.log(res.data)
          that.draft.show = res.data.show
          that.draft.title = res.data.title
          that.draft.category = res.data.category
          that.draft.description = res.data.description
          that.draft.editor_choice = res.data.editor_choice
          that.draft.cover = res.data.cover
          that.draft.poster = res.data.poster
          that.draft.images = res.data.images
          that.draft.audios = res.data.audios
          that.draft.trails = res.data.trails
          that.draft.price = res.data.price
          that.draft.published = res.data.published
        })
      }
    },
    mounted () {
      window.console.log("组件启动")
      this.getCategories(this.showSlug)
      this.getPrices(this.showSlug)
      if (this.mode == 'create') {
        this.loadFromLocalStorage()
      } else if (this.mode == 'update') {
        this.getEpisode(this.episodeId)
      }
    },
    destroyed () {
      window.console.log("组件卸载")
      if (this.mode == 'create' && this.submitting == false) {
        this.saveToLocalStorage(this.draft)
      }
    }
  }
</script>

<style lang="css" scoped>
  .line {
    text-align: center;
  }
  /* h5 {
    margin-top: 0;
    padding-left: 8px;
    border-left: 2px solid #409EFF;
  } */
</style>
